module.exports = __webpack_public_path__ + "img/revission.f8ca1a9f.svg";